export function tab() {
  //タブグループ取得
  const tabs = document.querySelectorAll('.js-tab');
  //Arrayに変換(IE対策)
  const tabsArr = Array.prototype.slice.call(tabs);

  tabsArr.forEach((tab) => {
    //ボタン取得
    const tabBtns = tab.querySelectorAll('.js-tabBtn');
    //Arrayに変換(IE対策)
    const tabBtnsArr = Array.prototype.slice.call(tabBtns);

    //パネル取得
    const tabPanels = tab.querySelectorAll('.js-tabPanel');
    const tabPanelsArr = Array.prototype.slice.call(tabPanels);

    for (let i = 0; i < tabBtns.length; i++) {
      tabBtns[i].addEventListener('click', tabSwitch, false);
    }

    function tabSwitch() {
      //ボタン切り替え
      tabBtnsArr.forEach((tabBtn) => {
        tabBtn.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // パネル切り替え
      tabPanelsArr.forEach((tabPanel) => {
        tabPanel.classList.remove('is-view');
      });
      const index = tabBtnsArr.indexOf(this);
      tabPanelsArr[index].classList.add('is-view');
    }
  });
}